import { Container } from "@mui/material";

const ContainerLayout = ({ children }) => {
  return <Container maxWidth="lg">{children}</Container>;
};

export default ContainerLayout;
